import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.SUPER_ADMIN };
const notificationPath = "admin/notifications"

export const getNotifications = async () => {
  const path = `${notificationPath}/notification-list`;
  return await axiosInstance(options).get(path);
};

export const markNotificationAsSeen = async (data) => {
  const path = `${notificationPath}/notification-list/mark-as-seen`;
  return await axiosInstance(options).post(path,data);
};